import { HttpErrorResponse, HttpEventType, HttpResponse } from '@angular/common/http';
import { Component, ElementRef, Inject, Input, ViewChild } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { TranslateService } from '@ngx-translate/core';
import { isEmpty } from 'lodash';
import { UserFileService } from 'src/app/files/service/user-file.service';

@Component({
  selector: 'app-upload',
  templateUrl: './upload.component.html',
  styleUrls: ['./upload.component.scss']
})
export class UploadComponent {
  @ViewChild('fileInput')
  fileInput: ElementRef;

  @Input() title: string = 'addFiles';
  @Input() closable: boolean = false;
  @Input() multiple: boolean = true;

  selectedFiles?: FileList;
  progressInfos: Progress[] = [];
  errorMessage: string[] = [];
  uploadInProgress: boolean = false;
  uploadedCount: number = 0;
  extensions: string;
  private endpoint: string;

  constructor(@Inject(MAT_DIALOG_DATA) public data: UploadData, private fileService: UserFileService,
              private translate: TranslateService, private ref: MatDialogRef<UploadComponent>) {
    this.endpoint = data.endpoint;
    this.extensions = data.extensions;
  }

  selectFiles(event: any): void {
    this.progressInfos = [];
    this.selectedFiles = event.target.files;
    this.uploadFiles();
  }

  uploadFiles(): void {
    if (this.selectedFiles) {
      for (let i = 0; i < this.selectedFiles.length; i++) {
        const file = this.selectedFiles[i];
        this.progressInfos[i] = { value: 0, fileName: file.name };
      }

      if (this.selectedFiles.length > 0) {
        this.uploadInProgress = true;
        this.upload(0);
      }
    }
  }

  upload(idx: number): void {
    const formData = new FormData();
    formData.append('file', this.selectedFiles[idx]);
    this.fileService.upload(formData, this.endpoint, this.extensions).subscribe(event => {
      if (event.type === HttpEventType.UploadProgress) {
        this.progressInfos[idx].value = Math.round(100 * event.loaded / event.total);
      } else if (event instanceof HttpResponse) {
        if (event.body.response.status < 0) {
          this.handleMessage(event.body.response.errors.code, idx, true);
        } else {
          const messages = event.body.response.data;
          if (!isEmpty(messages)) {
            const entry = Object.entries(messages[0]).shift();
            this.handleMessage(entry[0], idx, false, entry[1]);
          }
          this.uploadedCount++;
        }
        this.uploadNext(idx);
      }
    },
      (error: HttpErrorResponse) => {
        this.handleMessage(error.status.toString(), idx, true);
        this.uploadNext(idx);
      }
    );
  }

  uploadNext(idx: number): void {
    if (idx < this.selectedFiles.length - 1) {
      this.upload(idx + 1);
    } else {
      this.uploadInProgress = false;
      if (this.selectedFiles?.length == this.uploadedCount && this.closable)
        this.ref.close(this.uploadedCount);
    }
  }


  handleMessage(code: any, idx: number, error: boolean, uploadMessage?: string): void {
    switch (code) {
      case '415': {
        this.translate.get('uploadError415').subscribe(message => Object.assign(this.progressInfos[idx], { message, error }));
        break;
      }
      case '409': {
        this.translate.get('uploadError409').subscribe(message => Object.assign(this.progressInfos[idx], { message, error }));
        break;
      }
      case '500': {
        this.translate.get('uploadError500').subscribe(message => Object.assign(this.progressInfos[idx], { message, error }));
        break;
      }
      default: {
        if (error)
          this.translate.get('uploadUncategorizedError').subscribe(message => Object.assign(this.progressInfos[idx], { message, error }));
        else if (uploadMessage) {
          this.translate.get(uploadMessage.split(' ')).subscribe(value => {
            const message = typeof value === 'string' ? value : Object.values(value).join(' ');
            Object.assign(this.progressInfos[idx], { message, error });
          });
        } else
            break;
      }
    }
  }

  openFilesInput(): void {
    this.fileInput.nativeElement.click();
  }
}

export interface Progress {
  fileName: string;
  value: number;
  message?: string;
  error?: boolean;
}

export interface UploadData {
  endpoint: string;
  extensions: string;
}
